import { ReactNode } from "react";

export const ConsolidatedBanner = ({
  title,
  description,
  badge,
  children,
}: {
  title: string;
  description: ReactNode;
  badge?: ReactNode;
  children?: ReactNode;
}) => {
  return (
    <div>
      <div className="rounded-t-lg border border-zinc-300 bg-zinc-100 p-3">
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold">{title}</span>
          <div className="flex-none">{badge}</div>
        </div>
      </div>
      <div className="rounded-b-lg border border-t-0 border-zinc-300 bg-white p-4">
        <div className="flex flex-col gap-2 text-sm">
          {description}
          {children}
        </div>
      </div>
    </div>
  );
};
